/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlurredImage, CosmosAsset, CosmosTagProps, OptimizedCosmosAssetFragment } from "@components/elements";

import { styled } from "./ContentLargeImage.Media.styles";
import { cx } from "@panda/css";
import { BlogTagFragment } from "@cosmos/hygraph-schema";

export interface ContentLargeImageMediaProps {
	asset?: OptimizedCosmosAssetFragment | null;
	tags?: CosmosTagProps[] | BlogTagFragment[] | null;
	blurredImage?: OptimizedCosmosAssetFragment | null;
	disableAutoplay?: boolean | null;
	className?: string;
	isFirstSection?: boolean;
}

export const ContentLargeImageMedia = ({
	asset,
	tags,
	blurredImage,
	disableAutoplay,
	className,
	isFirstSection,
}: ContentLargeImageMediaProps): React.JSX.Element | null => {
	if (!asset) return null;

	//If the blurred image isn't provided and the primary asset is an image, we use it
	let finalBlurredImage = blurredImage;
	if (!finalBlurredImage) {
		finalBlurredImage = asset;
	}

	const sizedAsset: OptimizedCosmosAssetFragment = {
		...(asset || {}),
		url: asset?.url || "",
		width: 900,
	};

	return (
		<div className={cx("content-large-image-hero-image", styled, className)}>
			<div className="image-holder">
				<BlurredImage
					image={finalBlurredImage}
					width={900}
					height={506.25}
					opacity={0.8}
					blurPixels={90}
					disableAutoplay
				/>
				<div className="asset-wrap">
					<CosmosAsset
						className="cosmos-asset"
						asset={sizedAsset}
						tags={tags}
						disableAutoplay={disableAutoplay || false}
						eager={isFirstSection}
					/>
				</div>
			</div>
		</div>
	);
};
